import { topicItems } from '@/mocks/home';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-hashtag"></i>
            大家都在聊
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            发现韩漫圈最热门的话题讨论
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicItems.map((topic, idx) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all whitespace-nowrap ${
                idx === 0
                  ? 'bg-primary-500 border-primary-500 text-background-50'
                  : idx === 1
                  ? 'bg-accent-500 border-accent-500 text-background-50'
                  : 'bg-background-50 border-background-200/70 text-foreground-700 hover:border-primary-200/50 hover:text-primary-500'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-[11px] ${
                idx === 0 ? 'text-background-50/70' :
                idx === 1 ? 'text-background-50/70' :
                'text-foreground-400'
              }`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <p className="text-xs text-foreground-400">
            话题数据基于最近7天读者互动统计，每日自动更新
          </p>
        </div>
      </div>
    </section>
  );
}